export default {
    border: {type: Boolean, default: false},
    column: {type: Number, default: 2},
    direction: {type: String, default: 'horizontal'},
    size: {type: String},
    title: {type: String, default: ''},
    extra: {type: String, default: ''},
    labelStyle: {type: Object},
    contentStyle: {type: Object},
    labelClassName: {type: String, default: ''},
    contentClassName: {type: String, default: ''},
    colon: {type: Boolean, default: true},

    // 描述
    columns: {type: Array},
    // 值
    data: {type: Object},
    // 是否显示空值
    showNull: {type: Boolean, default: true}
}
